<template>
  <div ref="element" class="infos-container" :style="styleTranslateEffect">
    <DialogTrophiesInfosItemArrow
      v-for="(trophy, i) in trophies"
      :key="`arrow-${trophy.id}`"
      :visible="indexUsed === i"
      :index="i"
    />
    <DialogTrophiesInfosItem
      v-for="(trophy, i) in trophies"
      :key="trophy.id"
      class="item"
      :title="trophy.shortTitle"
      :container-width="width"
      :description="trophy.winTextField"
      :visible="indexUsed === i"
      :index="i"
      :positions="itemPositions"
      :offset-x="relativeX[i] || 0"
      @update-postion="handleUpdateItemPosition"
    />
  </div>
</template>
<script setup lang="ts">
// @ts-ignore
import { spring } from 'vue3-spring';

interface Props {
  trophies: TrophySchema[];
  index: number;
  iconPositions: number[];
  offsetX: number;
}

const props = defineProps({
  trophies: null,
  index: null,
  iconPositions: null,
  offsetX: null
});

const element = ref();

const relativeX = ref<number[]>([...Array(props.trophies.length).keys()]);

const { width } = useElementSize(element);

const translate = ref<number>(0);

const indexUsed = ref<number>(-1);

const borderWidth = computed(() => {
  return (-props.offsetX + props.iconPositions[0]) * 0.5;
});

const translateEffect = spring(translate, {
  damping: 12,
  stiffness: 60,
  mass: 1,
  from: 0,
});

const styleTranslateEffect = computed(() => {
  return {
    transform: `translateX(${translateEffect.value}px)`,
  };
});

const itemPositions = ref<number[]>([...Array(props.trophies.length).keys()]);

const handleUpdateItemPosition = (index: number, position: number) => {
  itemPositions.value[index] = position;
};

watchEffect(() => {
  if (
    props.iconPositions[props.index] < borderWidth.value ||
    props.iconPositions[props.index] > width.value - borderWidth.value
  ) {
    indexUsed.value = -1;
  } else {
    indexUsed.value = props.index;
  }
});

watchEffect(() => {
  try {
    translate.value = props.iconPositions[props.index];
  } catch (e) {
    console.info('not ready');
  }
});

watchEffect(() => {
  for (let i = 0; i < props.iconPositions.length; ++i) {
    const rectItem = {
      left: props.iconPositions[i] - itemPositions.value[i] * 0.5,
      right: props.iconPositions[i] + itemPositions.value[i] * 0.5,
    };

    if (rectItem.left < borderWidth.value * 0.5) {
      relativeX.value[i] = -rectItem.left + borderWidth.value * 0.1;
    } else if (rectItem.right > width.value - borderWidth.value * 0.5) {
      relativeX.value[i] =
        width.value - borderWidth.value * 0.1 - rectItem.right;
    } else {
      relativeX.value[i] = 0;
    }
  }
});
</script>
<style lang="scss" scoped>
.infos-container {
  display: flex;
  position: relative;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: 100%;
  gap: 0;
  margin: 1rem 0;
}
.item {
  flex: 0 0 auto;
}
</style>
